import { Logger } from "../Logger";
import { isUnitTest } from "gather-env-config/dist/src/public/envShared";
export function createWorker(comlink, getRawWorker) {
    let worker;
    if (process.env.BROWSER_EXTENSION) {
        worker = {};
    }
    else if (isUnitTest) {
        Logger.error(`
Do not import real web workers in unit tests. Instead, mock out the worker client file that wraps
the web worker in a usable interface, e.g.

    jest.mock('path/to/myWorker.client')

`);
        throw new Error("Unmocked web worker detected in unit tests");
    }
    else {
        worker = comlink.wrap(getRawWorker());
    }
    return worker;
}
//# sourceMappingURL=create.js.map